export default {
      id: "move-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#move-usage",
      toString: function () {
        return this.url;
      }
    }